import * as React from 'react';
import { SVGProps } from 'react';

const LiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <circle cx={4.996} cy={13} r={5} fill="#fff" fillOpacity={0.3} />
    <circle cx={5.004} cy={9} r={5} fill="#FBFBFB" fillOpacity={0.5} />
    <circle cx={5.004} cy={5} r={5} fill="#fff" />
  </svg>
);
export default LiveIcon;
